import React, { useState } from 'react';
import { Search, Bell, Menu, ScanLine, X, LogOut } from 'lucide-react';
import { useSelector, useDispatch } from 'react-redux';
import { setSearchQuery as setBookSearchQuery, setScanModalOpen } from '../store/slices/booksSlice';
import { setSearchQuery as setMemberSearchQuery } from '../store/slices/membersSlice';
import { setIsLoggedIn } from '../store/slices/userSlice';
import LibraryInfoModal from './LibraryInfoModal';

export default function Header({ onMenuClick, activeTab }) {
    const dispatch = useDispatch();
    const { currentUser } = useSelector((state) => state.user);
    const { searchQuery: bookSearchQuery } = useSelector((state) => state.books);
    const { searchQuery: memberSearchQuery } = useSelector((state) => state.members);
    const [isLibraryInfoOpen, setIsLibraryInfoOpen] = useState(false);

    const isSearchVisible = activeTab === 'Books' || activeTab === 'Members';
    const currentSearchQuery = activeTab === 'Books' ? bookSearchQuery : memberSearchQuery;
    const searchPlaceholder = activeTab === 'Books' ? "Rechercher un livre..." : "Rechercher un membre...";

    const handleSearchChange = (val) => {
        if (activeTab === 'Books') dispatch(setBookSearchQuery(val));
        if (activeTab === 'Members') dispatch(setMemberSearchQuery(val));
    };

    const handleClearSearch = () => {
        if (activeTab === 'Books') dispatch(setBookSearchQuery(''));
        if (activeTab === 'Members') dispatch(setMemberSearchQuery(''));
    };

    return (
        <>
            <header className={`h-20 px-4 lg:px-8 flex items-center justify-between bg-card/50 backdrop-blur-xl border-b border-border sticky top-0 z-40 ${currentUser.role !== "invité" ? "lg:ml-72" : ""}`}>
                <div className="flex items-center gap-4">
                    {/* Mobile Menu Button */}
                    {currentUser.role !== "invité" && (
                        <button
                            onClick={onMenuClick}
                            className="p-2 rounded-lg hover:bg-muted transition-colors lg:hidden"
                        >
                            <Menu size={24} className="text-foreground" />
                        </button>
                    )}

                    {(currentUser.role === "Bibliothécaire" || currentUser.role === "Enseignant") && <button
                        onClick={() => dispatch(setScanModalOpen(true))}
                        className="p-2 bg-muted/50 rounded-lg hover:bg-muted transition-colors text-foreground flex items-center gap-2"
                        title="Scanner un code QR"
                    >
                        <ScanLine size={20} /> <span className="hidden xs:inline">QR Code</span>
                    </button>}

                    {/* Search Bar */}
                    {isSearchVisible && (
                        <div className="relative flex-1 max-w-[400px]">
                            <Search className="absolute left-3 top-1/2 -translate-y-1/2 text-muted-foreground h-4 w-4" />
                            <input
                                type="text"
                                placeholder={searchPlaceholder}
                                value={currentSearchQuery}
                                onChange={(e) => handleSearchChange(e.target.value)}
                                className="w-full bg-muted/50 border border-border rounded-xl py-2 pl-10 pr-10 text-sm text-foreground placeholder:text-muted-foreground focus:outline-none focus:ring-2 focus:ring-primary/50"
                            />
                            {currentSearchQuery && (
                                <button
                                    onClick={handleClearSearch}
                                    className="absolute right-3 top-1/2 -translate-y-1/2 text-muted-foreground hover:text-white transition-colors"
                                >
                                    <X size={16} />
                                </button>
                            )}
                        </div>
                    )}

                </div>

                <div className="flex items-center gap-4">
                    <button
                        onClick={() => setIsLibraryInfoOpen(true)}
                        className="relative p-2 hover:bg-muted rounded-lg transition-colors"
                    >
                        <Bell size={20} className="text-foreground" />
                        <span className="absolute top-1 right-1 w-2 h-2 bg-primary rounded-full"></span>
                    </button>

                    <div className="flex items-center gap-3 px-3 py-2 rounded-xl hover:bg-muted transition-colors cursor-pointer">
                        <img
                            src={currentUser.avatar}
                            alt="Profile"
                            className="w-8 h-8 rounded-full border-2 border-primary"
                        />
                        <div className="hidden md:block">
                            <p className="text-sm font-medium text-foreground">{currentUser.name}</p>
                            <p className="text-xs text-muted-foreground">{currentUser.role}</p>
                        </div>
                    </div>

                    {currentUser.role === "invité" && (
                        <button
                            onClick={() => dispatch(setIsLoggedIn(false))}
                            className="p-2 hover:bg-red-500/20 text-red-500 rounded-lg transition-colors flex items-center gap-2"
                            title="Se déconnecter"
                        >
                            <LogOut size={20} />
                            <span className="hidden sm:inline text-sm font-medium">Déconnexion</span>
                        </button>
                    )}
                </div>
            </header>

            <LibraryInfoModal
                isOpen={isLibraryInfoOpen}
                onClose={() => setIsLibraryInfoOpen(false)}
            />
        </>
    );
}
